// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as GatsbyLink from "gatsby-link";
import * as TypographyJs from "../utils/typography.js";


function rhythm(prim) {
  return TypographyJs.rhythm(prim);
}

function scale(prim) {
  return TypographyJs.scale(prim);
}

function Layout(Props) {
  var $$location = Props.location;
  var title = Props.title;
  var children = Props.children;
  var rootPath = __PATH_PREFIX__ + "/";
  var header = $$location.pathname === rootPath ? React.createElement("div", undefined, React.createElement("a", {
            style: {
              float: "right",
              marginBottom: "30px",
              marginTop: "20px",
              fontSize: "1.3em",
              fontFamily: "'VT323', monospace"
            },
            href: "https://www.yonaymoris.me/",
            className: "homefolio"
          }, "yonafolio \u30FD(*\u30FB\u03C9\u30FB)\uFF89"), React.createElement("h1", {
          style: {
            fontSize: TypographyJs.scale(1.5).fontSize,
            lineHeight: TypographyJs.scale(1.5).lineHeight,
            marginTop: "0",
            float: "left",
            marginBottom: TypographyJs.rhythm(1.5)
          }
        }, React.createElement(GatsbyLink.default, {
              to: "/",
              style: {
                color: "inherit",
                textDecoration: "none",
                boxShadow: "none"
              },
              children: title
            }))) : React.createElement("i", { className: "fas fa-angle-left"}, React.createElement("h3", {
          style: {
            fontFamily: "Inconsolata, monospace",
            marginTop: "0"
          }
        }, React.createElement(GatsbyLink.default, {
              to: "/",
              style: {
                color: "inherit",
                textDecoration: "none",
                boxShadow: "none"
              },
              children: title
            })));

  return React.createElement("div", {
              style: {
                marginRight: "auto",
                marginLeft: "auto",
                maxWidth: "960px",
                padding: TypographyJs.rhythm(1.5) + (" " + TypographyJs.rhythm(0.75)) + " 5px" 
              }
            }, React.createElement("header", undefined , header), React.createElement("main", { style: { clear: "both"}} , children), React.createElement("footer", {style: {fontFamily: "'Mulish', sans-serif", fontSize: "0.8em"}}, "© built during the year of masks and social distancing by ", React.createElement("a", {
                      style: {
                        fontSize: "1.3em",
                        fontFamily: "'VT323', monospace"
                      },
                      className: "signature",
                      href: "https://www.yonaymoris.me/"
                    }, "yonaymoris") , " with ", React.createElement("a", {
                      href: "https://www.gatsbyjs.org"
                    }, "Gatsby")));

}
Layout.displayName = "Layout";

var Link;

var make = Layout;

var $$default = Layout;

export {
  Link ,
  rhythm ,
  scale ,
  make ,
  $$default ,
  $$default as default,

}
/*  Not a pure module */
